// import { Tab } from "react-bootstrap";
// import { useTranslation } from "react-i18next";

// const DetailedAccountStatusTable = ({ detailedData }) => {
//   const { t } = useTranslation();
//   return (
//     <div className="services-table-wrapper">
//       <table className="services-table mass-account-table">
//         <thead>
//           <tr>
//             <th>{t("mass_name_label")}</th>
//             <th>{t("region_label")}</th>
//             <th>{t("service_name_label")}</th>
//             <th>{t("plan_name_label")}</th>
//             <th>{t("mass_code_label")}</th>
//             <th>{t("status_label")}</th>
//             <th>{t("order_date_label")}</th>
//             <th>{t("release_date_label")}</th>
//             <th>{t("end_date_label")}</th>
//             <th>{t("price_label")}</th>
//             <th>{t("auto_debit_label")}</th>
//             <th>{t("account_balance_label")}</th>
//             <th>{t("account_balance_timestamped_label")}</th>
//             <th>{t("no_of_active_services_label")}</th>
//           </tr>
//         </thead>
//         <tbody>
//           {detailedData && detailedData.length > 0 ? (
//             detailedData.map((item, index) => (
//               <TableRow key={index} item={item} />
//             ))
//           ) : (
//             <tr>
//               <td colSpan="15" className="px-6 py-4 text-center">
//                 {t("no_data_available")}
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// const TableRow = ({ item }) => {
//   const { t } = useTranslation();

//   const formatDate = (dateStr) => {
//     if (!dateStr) return "";
//     const d = new Date(dateStr);
//     return isNaN(d.getTime()) ? "" : d.toLocaleDateString();
//   };

//   return (
//     <tr>
//       <td data-label={t("mass_name_label")}>{item.massName ?? "-"}</td>
//       <td data-label={t("region_label")}>{item.region ?? "-"}</td>
//       <td data-label={t("service_name_label")}>{item.serviceName ?? "-"}</td>
//       <td data-label={t("plan_name_label")}>{item.planName ?? "-"}</td>
//       <td data-label={t("mass_code_label")}>{item.massCode ?? "-"}</td>
//       <td data-label={t("status_label")}>{item.status ?? "-"}</td>
//       <td data-label={t("order_date_label")}>{formatDate(item.orderDate)}</td>
//       <td data-label={t("release_date_label")}>{formatDate(item.releaseDate)}</td>
//       <td data-label={t("end_date_label")}>{formatDate(item.endDate)}</td>
//        <td data-label={t("price_label")}>
//         {item.price !== undefined && item.price !== null && !isNaN(item.price)
//           ? Number(item.price).toFixed(2)
//           : "-"}
//       </td>
//       <td data-label={t("auto_debit_label")}>
//         {item.autoDebit
//           ? item.autoDebit.toLowerCase() === "yes"
//             ? t("yes")
//             : t("no")
//           : "-"}
//       </td>
//       <td data-label={t("account_balance_label")}>{item.accountBalance ?? "-"}</td>
//       <td data-label={t("account_balance_timestamped_label")}>
//         {item.accountBalanceTimestamp
//           ? new Date(item.accountBalanceTimestamp).toLocaleString()
//           : "N/A"}
//       </td>
//       <td data-label={t("no_of_active_services_label")}>{item.activeServicesCount ?? "-"}</td>
//     </tr>
//   );
// };




// export default DetailedAccountStatusTable;

import { useTranslation } from "react-i18next";
import React, { useMemo } from "react";

const DetailedAccountStatusTable = ({ detailedData, isOnboardingLoading }) => {
  const { t } = useTranslation();

  // Define all columns in one place
  const columns = useMemo(
    () => [
      { key: "massName", label: t("mass_name_label") },
      { key: "region", label: t("region_label") },
      { key: "serviceName", label: t("service_name_label") },
      { key: "planName", label: t("plan_name_label") },
      { key: "massCode", label: t("mass_code_label") },
      { key: "status", label: t("status_label") },
      { key: "orderDate", label: t("order_date_label") },
      { key: "releaseDate", label: t("release_date_label") },
      { key: "endDate", label: t("end_date_label") },
      { key: "price", label: t("price_label") },
      { key: "autoDebit", label: t("auto_debit_label") },
      { key: "accountBalance", label: t("account_balance_label") },
      { key: "accountBalanceTimestamp", label: t("account_balance_timestamped_label") },
      { key: "activeServicesCount", label: t("no_of_active_services_label") },
    ],
    [t]
  );

  const hasManyColumns = columns.length > 10;

  return (
    <div
      className={`services-table-wrapper mass-account-wrapper ${
        hasManyColumns ? "scrollable" : ""
      }`}
    >
      <table
        className={`services-table mass-account-table ${
          hasManyColumns ? "has-many-columns" : ""
        }`}
      >
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {detailedData && detailedData.length > 0 ? (
            detailedData.map((item, index) => (
              <TableRow key={index} item={item} columns={columns} isOnboardingLoading={isOnboardingLoading} />
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="px-6 py-4 text-center">
                {t("no_data_available")}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

const TableRow = ({ item, columns, isOnboardingLoading }) => {
  const { t } = useTranslation();

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? "" : d.toLocaleDateString();
  };

  const renderCell = (key) => {
    switch (key) {
      case "orderDate":
      case "releaseDate":
      case "endDate":
        return formatDate(item[key]);
      case "price":
        return item.price !== undefined && item.price !== null && !isNaN(item.price)
          ? Number(item.price).toFixed(2)
          : "-";
      case "autoDebit":
        return item.autoDebit
          ? ["yes", "true"].includes(item.autoDebit.toLowerCase())
            ? t("yes")
            : t("no")
          : "-";
      case "accountBalance":
        if (item.accountBalance === null && isOnboardingLoading)
          return <span style={{ color: "#999", fontStyle: "italic" }}>Loading...</span>;
        if (item.accountBalance === undefined || item.accountBalance === null) return "N/A";
        if (Number.isNaN(Number(item.accountBalance))) return "N/A";
        return `₹${Number(item.accountBalance).toFixed(2)}`;
      case "accountBalanceTimestamp":
        if (item.accountBalanceTimestamp === null && isOnboardingLoading)
          return <span style={{ color: "#999", fontStyle: "italic" }}>Loading...</span>;
        if (item.accountBalanceTimestamp) {
          return new Date(item.accountBalanceTimestamp).toLocaleString();
        }
        return "N/A";
      case "activeServicesCount":
        return item.activeServicesCount !== undefined &&
          item.activeServicesCount !== null &&
          !Number.isNaN(Number(item.activeServicesCount))
          ? String(item.activeServicesCount)
          : "-";
      default:
        return item[key] ?? "-";
    }
  };

  return (
    <tr>
      {columns.map((col) => (
        <td key={col.key} data-label={col.label}>
          {renderCell(col.key)}
        </td>
      ))}
    </tr>
  );
};

export default DetailedAccountStatusTable;
